export default __webpack_public_path__ + "static/media/home-hand-dark.fcf7984d.png";